<template>
  <div>&nbsp;</div>
</template>

<script>
export default {
  name: 'redirect',
  mounted () {
    this.$router.replace(this.$route.query.target ? this.$route.query.target : { name: 'home' }).catch(() => {})
  }
}
</script>
